const couponTypes = {
	GET_COUPON: {
		REUQEST: 'COUPON_GET_REQUEST',
		SUCCESS: 'COUPON_GET_SUCCESS',
		FAILURE: 'COUPON_GET_FAILURE',
		CLEAR: 'COUPON_GET_CLEAR',
	},
	INVALIDATE_COUPON: {
		REUQEST: 'COUPON_INVALIDATE_REQUEST',
		SUCCESS: 'COUPON_INVALIDATE_SUCCESS',
		FAILURE: 'COUPON_INVALIDATE_FAILURE',
	},
	GET_COUPON_MOBILE: {
		REUQEST: 'COUPON_MOBILE_REQUEST',
		SUCCESS: 'COUPON_MOBILE_SUCCESS',
		FAILURE: 'COUPON_MOBILE_FAILURE',
	},
};

export default couponTypes;
